import isEmpty from 'lodash/isEmpty';
import {
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK,
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
} from '@eventbrite/social-login-facebook';

import { setAccountExistent } from './auth';
import { socialLogInUser } from './social';

/**
 * Function to trick the app and make set it in the state after a call to an external provider
 */
export const onSkipSocialLinks = () => (dispatch, getState) => {
    const {
        socialDataMock,
        social: { socialProvider },
    } = getState();
    const socialMock = socialDataMock[socialProvider];

    if (!isEmpty(socialMock)) {
        if (socialMock.email) {
            dispatch(setAccountExistent(socialMock.email));
        }

        if (socialProvider === SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE) {
            window.AppleID = {};
            window.AppleID.auth = {
                signIn: () => {
                    const appleConfirmation = confirm('Continue with apple?');

                    /* istanbul ignore next */
                    if (appleConfirmation) {
                        return Promise.resolve(socialMock);
                    } else {
                        /* istanbul ignore next */
                        return Promise.reject({
                            status: 'popup_closed_by_user',
                        });
                    }
                },
            };
        }

        if (socialProvider === SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK) {
            window.FB = {};
            window.FB.login = () => {
                const fbConfirmation = confirm('Continue with facebook?');

                /* istanbul ignore next */
                if (fbConfirmation) {
                    dispatch(socialLogInUser(socialMock));
                } else {
                    /* istanbul ignore next */
                    return false;
                }
            };
            window.FB.getLoginStatus = () => {};
        }

        if (socialProvider === SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE) {
            const auth2 = {
                signIn: () => {
                    const googleConfirmation = confirm('Continue with Google?');

                    /* istanbul ignore next */
                    if (googleConfirmation) {
                        dispatch(socialLogInUser(socialMock));
                    }

                    return Promise.resolve();
                },
                init: () => {},
            };

            window.gapi = {
                load: (_, callback) => {
                    /* istanbul ignore next */
                    callback();
                },
                auth2: {
                    getAuthInstance: () => auth2,
                },
            };
        }
    }
};

export const onSkipEmailDelivery = ({ callback }) => {
    setTimeout(callback?.(), 5000);
};
